module.exports = __webpack_public_path__ + "img/icon-button-resolve.ba0096b7.svg";